<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col sm="12">
                <b-card>
                    <div slot="header">
                        <strong>{{title}} </strong>
                    </div>
                    <b-row>
                        <b-col sm="12">
                            <label>Self Pick Up</label>
                            <b-form-input type="text" v-model="wsi.location_full"></b-form-input>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="12">
                            <label for="remarks">Remarks</label>
                            <textarea class="form-control" rows="5" id="remarks" v-model="wsi.remarks"></textarea>
                        </b-col>
                    </b-row>
                    <br/>
                    <b-row>
                        <b-col sm="4">
                            <label>Location From (Warehouse)</label>
                                <b-form-input type="text" v-model="wsi.location_full" disabled></b-form-input>
                        </b-col>
                        <b-col sm="4">
                                <label for="invoive" >Tax Invoice</label>
                                    <b-form-input type="text" v-model="wsi.invoice_num" disabled></b-form-input>
                        </b-col>
                        <b-col sm="4">
                            <label for="trans_date" >Transaction Date</label>
                                <b-form-input type="date" v-model="wsi.trans_date" disabled></b-form-input>
                        </b-col>
                    </b-row>
                    <br/>
                    <b-row>
                        <b-col sm="4">
                            <label for="trans_loc" >Transaction Location</label>
                                <b-form-input type="text" v-model="wsi.trans_loc" disabled></b-form-input>
                        </b-col>
                        <b-col sm="4">
                            <label for="status" >Status</label>
                                <b-form-input type="text" v-model="wsi.status" disabled></b-form-input>
                        </b-col>
                        <b-col sm="4">
                                <label for="customer" >IBO/Stockist</label>
                                    <b-form-input type="text" v-model="wsi.customer_full" disabled></b-form-input>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="4">
                            <label for="customer">Shipping Method</label>
                                <b-form-input type="text" v-model="wsi.shipping_method" disabled></b-form-input>
                        </b-col>
                        <b-col sm="4">
                                <label for="contact">Contact Number</label>
                                    <b-form-input type="text" v-model="wsi.contact_num" disabled></b-form-input>
                            </b-col>
                        <b-col sm="4">
                            <label v-if="1">Shipping Address</label>
                            <label v-if="0">Pick Up Location</label>
                                <textarea class="form-control" rows="3" v-model="wsi.shipping_address" disabled></textarea>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
        <b-row>
                <b-col sm="12">
                    <b-card>
                        <div slot ="header">
                            <strong>Stock Issuance Items</strong>
                        </div>
                        <div class="table-responsive">
                            <table class='table table-striped table-bordered'>
                                <thead>
                                    <th>Product Name</th>
                                    <th >Product Code</th>
                                    <th>SOH</th>
                                    <th>Order Qty</th>
                                    <th>Update Alloc. Qty</th>
                                    <th>O/S Qty</th>
                                    <th>Delivered Qty</th>
                                </thead>
                                <tbody>
                                    <tr v-for="row, index in wsi.wsi_items" >
                                        <td width="300px">{{row.prodct_name}}</td>
                                        <td width="250px">{{row.product_id}}</td>
                                        <td width="200px">{{row.qty_soh}}</td>
                                        <td width="180px">{{row.order_qty}}</td>
                                        <td width="180px"><input type="number" min="0" name="qty" v-model="row.qty" class="form-control"/></td>
                                        <td width="180px">{{row.os_qty}}</td>
                                        <td width="180">{{row.delivered_qty}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div slot="footer">
                                <b-button type="submit" size="lg" variant="primary" @click="confirmGenerateDO" v-if="!showIssuanceRecord">Generate DO</b-button>
                        </div>
                        <b-modal v-model="modalShow" @ok="generateDO" @cancel="handleCancel" hide-header-close title="Confirm Generate DO"  centered header-bg-variant="success" no-close-on-backdrop no-close-on-esc>
                                <p style="color:darkblue">Confirmed Generate?</p>
                        </b-modal>
                    </b-card>
                </b-col>
        </b-row>
        <b-row v-if="showIssuanceRecord">
            <b-col sm="12">
                <b-card>
                    <div slot ="header">
                        <strong>Stock Issuance Records</strong>
                    </div>
                    <div class="table-responsive">
                        <table class='table table-striped table-bordered'>
                                <thead>
                                    <th>PickList Date</th>
                                    <th>PickList No</th>
                                    <th>Created By</th>
                                    <th>Do Date</th>
                                    <th>Do No</th>
                                    <th>Created By</th>
                                    <th>Courier Company</th>
                                    <th>Courier No</th>
                                </thead>
                                <tbody>
                                    <tr v-for="row, index in wsi.pickListInfo" >
                                        <td width="300px">{{row.picklist_date}}</td>
                                        <td width="250px">{{row.picklist_num}}</td>
                                        <td width="200px">{{row.pl_author_user_shortname}}</td>
                                        <td width="180px">{{row.do_date}}</td>
                                        <td width="180px">{{row.do_num}}</td>
                                        <td width="180px">{{row.do_author_user_shortname}}</td>
                                        <td width="180px"><input type="text" min="0" name="courier_company_id" v-model="row.courier_company_id" class="form-control"/></td>
                                        <td width="180px"><input type="text" min="0" name="courier_num" v-model="row.courier_num" class="form-control"/></td>
                                    </tr>
                                    </tbody>
                            </table>
                    </div>
                </b-card>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-row style="padding: 0px 0px 20px 18px;">
                    <b-button type="submit" size ="lg" variant="primary">Save</b-button>
                    &nbsp;&nbsp;
                    <b-button type="submit" size ="lg" variant="danger">Cancel</b-button>
                    &nbsp;&nbsp;
                    <b-button type="submit" size="lg" variant="danger" @click="back">Back</b-button>
                </b-row>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import axios from 'axios'
import warehouseLookup from '@/components/Autocomplete.vue'
import countryLookup from '@/components/Autocomplete.vue'
import productLookup from '@/components/Autocomplete.vue'
import {authHeader, apiWarehouseLookup, apiLocationProductUrl,apiCountryLookup} from '@/functions/common.vue'
export default
{
    created()
    {
        this.wsi_ref = this.$route.params.wsiNum
        if(this.wsi_ref == '_new')
        {
            let curDate = new Date()
            curDate = curDate.toISOString().substr(0,10)
            this.wsi.wsi_date = curDate
            this.noItemsFound = true
        }
        else
        {
            this.lockEntry = true
            this.fetch(this.wsi_ref)
            this.noItemsFound = false
        }
    },
    data: () => {
        return {
            title:'Stock Issuance',
            apiWarehouseUrl:apiWarehouseLookup,
            apiCountryLookup:apiCountryLookup,
            apiLocationProductUrl:apiLocationProductUrl,
            wsi_ref: '',
            lockEntry:false,
            showIssuanceRecord:false,
            modalShow:false,
            errorMessage:'',
            wsi :
            {
                location_full:'',
                customer_full:'',
                invoice_num:'',
                trans_loc:'',
                self_pickup_id:'',
                picking_location:'',
                status:'',
                trans_date:'',
                channel:'',
                shipping_address:'',
                contact_num:'',
                remarks:'',
                pickListInfo:
                [
                    {picklist_date:'',picklist_num:'',pl_author_user_shortname:'',do_date:'',do_num:'',do_author_user_shortname:'',courier_company_id:'',courier_no:''}
                ],
                wsi_items :
                [
                  {product_name:'', product_id:'', qty_soh:'', order_qty:'',qty:'',os_qty:'',delivered_qty:''}
                ]
            }
        }
    },
    methods:
    {
        fetch(salesDocNo)
        {

        },
        confirmGenerateDO()
        {
            this.modalShow = true
        },
        generateDO()
        {
            this.showIssuanceRecord = true
        },
        handleCancel()
        {

        },
        back()
        {
            this.$router.push({ name: 'Stock Issuance'})
        },
        save()
        {

        },
        confirmSave()
        {

        }
    }
}
</script>


// WEBPACK FOOTER //
// src/views/wsi/wsi.vue